export default __webpack_public_path__ + "06e797210a73ce4083e8b8bdcc9e4d5b.png";